import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["panel", "tab", "status", "title", "duration", "previewTitle", "previewDuration", "previewVideo", "section"]
  connect() {
    this.updatePreview()
    const selected = this.tabTargets.find(tab => tab.dataset.panel === this.sectionTarget.value)
    if (selected) this.select({ currentTarget: selected })
    this.invalidHandler = event => this.revealInvalid(event.target)
    this.element.addEventListener("invalid", this.invalidHandler, true)
  }
  disconnect() { this.element.removeEventListener("invalid", this.invalidHandler, true) }
  revealInvalid(input) {
    const panel = input.closest("[data-scheduling-editor-target=panel]")
    const tab = this.tabTargets.find(item => item.dataset.panel === panel?.dataset.panel)
    if (tab) this.select({ currentTarget: tab })
  }
  select(event) {
    const selected = event.currentTarget.dataset.panel
    this.sectionTarget.value = selected
    this.panelTargets.forEach(panel => { panel.hidden = panel.dataset.panel !== selected })
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.panel === selected
      tab.classList.toggle("is-active", active)
      tab.setAttribute("aria-pressed", String(active))
    })
  }
  changed() {
    this.statusTarget.textContent = "Unsaved changes"
    this.updatePreview()
  }
  saving(event) {
    // Reveal the section containing the first invalid field so native browser
    // validation can focus it; required fields remain real form controls.
    const invalid = event.target.querySelector(":invalid")
    if (invalid) {
      const panel = invalid.closest("[data-scheduling-editor-target=panel]")
      const tab = this.tabTargets.find(item => item.dataset.panel === panel?.dataset.panel)
      if (tab) this.select({ currentTarget: tab })
    }
  }
  updatePreview() {
    if (this.hasTitleTarget) this.previewTitleTarget.textContent = this.titleTarget.value || "Meeting title"
    if (this.hasDurationTarget) this.previewDurationTarget.textContent = `${this.durationTarget.value || "—"} minutes`
    const provider = this.element.querySelector("input[name='meeting_type[conference_provider]']:checked")?.value
    const external = this.element.querySelector("input[name='meeting_type[mode]']:checked")?.value === "external"
    if (this.hasPreviewVideoTarget) this.previewVideoTarget.textContent = external ? "External booking link" : { zoom: "Zoom", google_meet: "Google Meet", "": "Custom location" }[provider] || "No location"
  }
}
